<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="main-container">
          <div class="row">
            <div class="page-content__header-description col-md-12" style="line-height: 35px; padding-bottom: 14px; border-bottom: 1px solid #c8c8c8;">Role List
              <b-button variant="primary" class="pull-right" @click="showModal">
                Add Role
              </b-button>
            </div>
            <b-modal centered  ref="myModalRef" hide-footer class="modal-dialog modal-content" role="document">
              <div slot="modal-header" style="text-align: center !important;"  >
                  <b-btn class="close custom-modal__close"  style="justify-content: center !important; font-size: .89em;"  @click="hideModal"> <span aria-hidden="true" class="fa fa-close"></span></b-btn>
                  <img src="/static/img/modal/4.png" alt="" class="">
                  <h2 class="page-content__header-description">Add Role</h2>
              </div>
              <div class="d-block text-center">
                 <b-alert variant="danger"
            dismissible
            :show="displayError">
              {{ errorMessage }}
          </b-alert>
                   <form action="#" class="p-userRole">
                    <div class="form-group">
          <input type="text" class="form-control form-control-lg" v-model="data.name" placeholder="Role Name">
        </div>
                  <textarea class="form-control form-control-lg" v-model="data.description" placeholder="Role Description"></textarea>
                <b-button size="md" variant="primary" style="margin-top: 12px;" @click="addRole">
                  Add &nbsp; <span class="fa fa-plus"></span>
                </b-button>
                   </form>
              </div>
            </b-modal>
          </div>
          <div class="row">
            <div style="width: 100%;">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :paginate="true"
                :globalSearch="true"
                styleClass="table table-striped col-md-12"
                >
                  <!-- <template slot="table-row" slot-scope="props">
                     <td data-label="Role" class="fancy"><a>{{ props.row.originalIndex+1 }}</a></td>
                    <td data-label="Role" class="fancy"><a>{{ props.row.name }}</a></td>
                     <td data-label="description" class="fancy"><a>{{ props.row.description }}</a></td>
                    <td data-label="Action" class="fancy">
                    <b-button variant="danger" style="margin-top: 12px;" @click="deleteData(props.row.id)">
                      <span id="delete" class="delete hide">{{ props.row.id }}</span><span class="fa fa-trash-o"></span>
                    </b-button></td>
                    </template> -->
              </vue-good-table>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";

import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
Vue.use(VuejsDialog);
/**
new Vue({
  
})**/

export default {
  data() {
    return {
      data: {
        name: null,
        description: null
      },
      responseData: "",
      errors: {},
      errorMessage: "",
      displayError: false,
      componentName: "",
      columns: [
        // {
        //   label: "SN",
        //   field: "counter",
        //   originalIndex: 0
        // },
        {
          label: "Role",
          field: "name",
          filterable: true
        },
        {
          label: "Description",
          field: "description",
          filterable: true
        },
        // {
        //   label: "Action"
        //   // field: 'age',
        // }
      ],
      rows: [{ name: null, description: null }]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateData() {
      var err = [];

      for (let [field, value] of Object.entries(this.data)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        if (value === "null" || value === "") {
          err[field] = field + " cannot be empty.";
        }
        if (field.toLowerCase == "email")
          if (!this.isEmail(value)) {
            err[field] = "Not a valid email.";
          }
      }
      this.errors = err;
    },
    addRole(e) {
      e.preventDefault();
      this.validateData();
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        console.log(this.errors);
        this.errorMessage = "Require Fields cannot be empty.";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 1000);
        this.showErrorMsg({ message: this.errorMessage });
      } else {
        var str = JSON.stringify(this.data);
        const tempData = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const container = this;

        HTTP.post("/roles", tempData)
          .then(response => {
            this.fetchData();
            this.$refs.myModalRef.hide();
          })
          .catch(error => {
            console.log("error", error);
            this.showErrorMsg({ message: "Error occur while saving!" });
          });
        // =========================
      }
    },
    deleteData(e) {
     // e.preventDefault();
//console.log(e);

     // return;
     // var roleId = e.srcElement.childNodes[0].innerHTML;

      const container = this;
      container.$dialog
        .confirm("Please confirm to continue")
        .then(function() {
          console.log("Clicked on proceed");
          console.log(e);

          const HTTP = container.$httpUtils.instance;
          HTTP.delete("/roles/" + e, {})
            .then(response => {
              container.fetchData();
            })
            .catch(error => {
              console.log("error", error);
              container.showErrorMsg({
                message: "Error occur while Deleting!"
              });
            });
        })
        .catch(error => {
          console.log("error", error);
          console.log("Clicked on cancel"); 
        });

      // =========================
    },
    doNothing() {
      return false;
    },

    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    fetchData() {
      const HTTP = this.$httpUtils.instance;
      const url = "/roles";
      HTTP.get(url, {})
        .then(dataResponse => {
          const dataList = dataResponse.data;
          let str = JSON.stringify(dataList);
          const tempData = JSON.parse(str);
          this.rows = tempData;
        })
        .catch(error => {
          console.log("error", error);
          this.showErrorMsg({ message: "Error occur while saving!" });
        });
    }
  },
  computed: {},
  mounted() {
    this.fetchData();
  }
};
</script>
<style>
.widget_box {
  min-height: auto !important;
}
.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
</style>




// WEBPACK FOOTER //
// src/components/pages/roles/index.vue